import moment from 'moment-timezone'

import { get } from 'lodash'
import { parseJwt } from '@/helpers'

const defaultRank = 60

export default {
    // Return the user as is from state
    user: state => {
        return state.user

        //return state.user
    },
    token: state => state.token,
    error: state => state.error,

    // Is the user being impersonated? true / false
    isImpersonated: (state, getters) => {
        return get(getters, 'tokenPayload.original_token', false)
    },

    // Can this user impersonate anyone? true / false
    canImpersonate: (state, getters) => {
        try {
            return state.user.role.rank < 30 && !getters.isImpersonated
        } catch (err) {
            return false
        }
    },

    // Is this user fully authenticated? true / false
    isAuthenticated: state => {
        return !!state.token
    },

    isLoading: state => {
        return state.loading
    },

    // Is this user global admin?
    isGlobalAdmin: state => {
        return get(state, 'user.role.rank', defaultRank) <= 20
    },

    // Is this user global admin?
    isCompanyAdmin: state => get(state, 'user.role.rank', defaultRank) <= 30,

    // Is this user global admin?
    isManager: state => get(state, 'user.role.rank', defaultRank) <= 50,

    tokenExpiration: state => {
        // Return 1970 if no token is set
        if (!state.token) {
            return moment.utc().year(1970)
        }

        let jwt = parseJwt(state.token)
        let exp = jwt.exp

        return moment.unix(exp)
    },

    tokenPayload: state => {
        try {
            return JSON.parse(atob(state.token.split('.')[1]))
        } catch (error) {
            return null
        }
    },
}
